query GetCharityCategory($id: ID!) {
  charityCategory(id: $id) {
    id
    name
    backgroundColour
    causeAreas
    icon
    excludeFromHifoSelection
    description
    exampleHifo {
      id
      name
    }
  }
}
